import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Trans } from 'react-i18next'
import AccessControl from '../../auth/AccessControl'
import { COMPANY_ADMIN } from '@constants/adminRoles'
import { history } from '@services/History'

export class ProfessionalTable extends Component {
  static defaultProps = {
    professionals: [],
  }

  static propTypes = {
    professionals: PropTypes.array,
  }

  render() {
    const { professionals, role } = this.props
    const isCompanyAdmin = role === COMPANY_ADMIN
    return (
      <table className="md-table">
        <thead>
          <tr>
            <th>
              <Trans>Nombre</Trans>
            </th>
            <th>
              <Trans>Avatar</Trans>
            </th>
            <AccessControl requiredRole="company">
              <th>
                <Trans>Número de colegiado</Trans>
              </th>
            </AccessControl>
            <th>
              <Trans>Especialidad</Trans>
            </th>
            <AccessControl requiredRole="provider">
              <th className="col-large">
                <Trans>Email</Trans>
              </th>
              <th>
                <Trans>Teléfono</Trans>
              </th>
            </AccessControl>
            <AccessControl>
              <th>
                <Trans>Compañías</Trans>
              </th>
              <th>
                <Trans>Proveedor</Trans>
              </th>
            </AccessControl>
          </tr>
        </thead>
        <tbody>
          {professionals.map((professional) => (
            <tr
              key={professional.id}
              className={!isCompanyAdmin && 'clickable'}
              onClick={() => !isCompanyAdmin && history.push(`/professional/${professional.id}`)}
            >
              <td className="col-center">{professional.name}</td>
              <td className="col-center">
                <img src={professional.avatar} style={{ height: 50, width: 50, objectFit: 'cover' }} alt="avatar" />
              </td>
              <AccessControl requiredRole="company">
                <td className="col-center">{professional.collegiate_number}</td>
              </AccessControl>
              <td className="col-center">{professional.speciality && professional.speciality.name}</td>
              <AccessControl requiredRole="provider">
                <td className="col-center">{professional.email}</td>
                <td className="col-center">{professional.phone}</td>
              </AccessControl>
              <AccessControl>
                <td className="col-center">
                  {professional.companies && professional.companies.map((company) => company.name).join(', ')}
                </td>
                <td className="col-center">{professional.provider && professional.provider.name}</td>
              </AccessControl>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
